export class UrlModel {
  public url: string;


  constructor(url: string) {
    this.url = url;
  }
}
